"use client";

import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";

import {
  testingServices,
  testingFaqs,
  testingHeroData,
  testingSolutionsAndProcessData,
  testingPortfolioData,
  testingMaintenanceAboutData,
} from "src/utils/mock/testingMaintenanceData";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import NavigationSection from "src/components/Common/NavigationSection";
import TechsSection from "src/components/Common/TechsSection";
import { flutterStatsData, flutterTechnologiesData } from "src/utils/mock/webAppData";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function TestingMaintenance({ caseStudies }) {
  const liveProjects = caseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    return project.projectStatus?.toLowerCase() === "active";
  });

  const filteredData = caseStudies
    ? {
        ...testingPortfolioData,
        projects: {
          liveProjects: activeProjects,
        },
      }
    : testingPortfolioData;
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={testingHeroData} />
      <TechStats stats={flutterStatsData} />
      <NavigationSection data={testingServices} />
      <WhyChooseUs data={testingSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Testing" sections={testingMaintenanceAboutData} />
        </div>
      </section>
      <FAQSection faqs={testingFaqs} />
      <CommonContactSection />
    </div>
  );
}
